export const OPERATIONS_OUTSIDE_BUSINESS_HOURS = 'OPERATIONS_OUTSIDE_BUSINESS_HOURS';
export const PRICING_RANGES_NOT_UPDATED = 'PRICING_RANGES_NOT_UPDATED';
export const AVAILABILITY_CHECK_ERROR = 'AVAILABILITY_CHECK_ERROR';
export const DEFAULT_UNAVAILABILITY_CODE = 'DEFAULT';

const SUMMARY_ACTION_BUTTON_TOOLTIP_BLOCKED_BY_CODE = {
  [OPERATIONS_OUTSIDE_BUSINESS_HOURS]:
    'El ingreso de operaciones está habilitado de lunes a viernes, entre las 9:00 y las 17:00 horas.',
  [PRICING_RANGES_NOT_UPDATED]:
    'La información de tasas aún no se ha actualizado al día de hoy.',
  [AVAILABILITY_CHECK_ERROR]:
    'No pudimos verificar la disponibilidad del servicio. Intenta más tarde.',
};

export const getSummaryActionButtonTooltipBlocked = (unavailabilityCode) => (
  SUMMARY_ACTION_BUTTON_TOOLTIP_BLOCKED_BY_CODE[unavailabilityCode]
    ?? SUMMARY_ACTION_BUTTON_TOOLTIP_BLOCKED_BY_CODE[OPERATIONS_OUTSIDE_BUSINESS_HOURS]
);
